/* eslint-disable no-unreachable */
import {
  AuthenticationResult,
  PublicClientApplication,
  SilentRequest,
} from '@azure/msal-browser';

import { msalConfig } from './authConfig';

const redirectUri = window.location.origin;

const msalInstance = new PublicClientApplication(msalConfig);

const getAccountIdStorageKey = (): string | null => {
  const account = msalInstance.getAllAccounts().at(0);
  return account ? `Account-Id:${account.homeAccountId}` : null;
};

const acquireTokenSilently = async (
  scopes: Array<string>
): Promise<AuthenticationResult | undefined> => {
  const myAccounts = msalInstance.getAllAccounts();
  const request: SilentRequest = {
    scopes,
    account: myAccounts[0],
    redirectUri,
  };
  let tokenResponse;
  await msalInstance
    .acquireTokenSilent(request)
    .then(result => {
      tokenResponse = result;
      return tokenResponse;
    })
    .catch(error => {
      msalInstance.acquireTokenRedirect({ ...request });
      throw error;
    });
  return tokenResponse;
};

const logout = (): void => {
  const storageKey = getAccountIdStorageKey();
  if (storageKey) localStorage.removeItem(storageKey);
  msalInstance.logoutRedirect();
};

export { msalInstance, acquireTokenSilently, logout, getAccountIdStorageKey };
